export default __webpack_public_path__ + "static/media/exportdata.1b02ef58.svg";